<template>
  <el-dialog
    title="产业知识产权运营中心信息公示"
    :visible.sync="league_dialogVisible"
    width="70%"
    :before-close="handleClose"
    :close-on-click-modal="true"
  >
    <div>
      <el-form :model="queryParams" ref="queryParamsRef" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="运营中心" prop="operationCenter">
              <el-input v-model="queryParams.operationCenter" placeholder="请输入运营中心 " clearable />
            </el-form-item>
          </el-col>
          <el-col style="text-align: center;">
            <el-button type="primary" icon="Search" @click="getList">搜索</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column type="index" width="55" label="序号" align="center">
          <template
            slot-scope="scope"
          >{{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="operationCenter" label="运营中心" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="contactPhone" label="联系电话" align="center" show-overflow-tooltip width="140"></el-table-column>
        <el-table-column prop="email" label="邮箱" align="center" show-overflow-tooltip width="200"></el-table-column>
        <el-table-column prop="officialAccount" label="公众号" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
  </el-dialog>
</template>
    <script>
import { industryList } from "@/api/index";
export default {
  props: {
    league_dialogVisible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      queryParams: {
        pageSize: 10,
        pageNum: 1,
      },
      tableData: [],
      total: 0
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleClose() {
      this.$emit("update:league_dialogVisible", false);
    },
    getList() {
      industryList({ ...this.queryParams }).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    }
  }
};
</script>
    <style lang="less" scoped>
.main {
  width: 1200px;
  min-height: calc(100vh - 421px);
  margin: 0px auto;
  background-color: #fff;
  margin-top: 20px;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 0px 20px;
}
/deep/ .el-dialog {
    margin-top: 8vh!important;
}
</style>